// Shared page footer: surfaces the "Shortcuts (?)" link on every page so
// keyboard discoverability isn't gated to Triage. The `?` keypress opens
// the same global overlay; this link is the visual hint.

import { useAppContext } from '../App';

export function PageFooter() {
  const { setShowShortcuts } = useAppContext();
  return (
    <footer className="border-t border-neutral-200 px-4 py-2 flex items-center justify-between text-[11px] text-neutral-500">
      <span>
        Granted by Commondoor
      </span>
      <button
        type="button"
        onClick={() => setShowShortcuts(true)}
        className="hover:text-neutral-700 underline-offset-2 hover:underline focus-visible:underline"
        aria-label="Show keyboard shortcuts (or press ?)"
      >
        Shortcuts <kbd className="font-mono text-[10px] bg-neutral-100 px-1 py-0.5 rounded border border-neutral-200 ml-1">?</kbd>
      </button>
    </footer>
  );
}
